import MarketingMainLayout from './MarketingMainLayout';

export interface LandingLayoutProps {
  children: React.ReactNode;
}

const LandingLayout = ({ children }: LandingLayoutProps) => {
  return <MarketingMainLayout navbar={{ variant: 'default' }}>{children}</MarketingMainLayout>;
};

export default LandingLayout;
